import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {UploadEvent} from "primeng/fileupload";
import {
  InsuranceDocumentDto,
  Partner, UserAddedInsuranceDocumentDto,
  UserAddedInsuranceDto
} from "../../../cross/user-insurance/types/ds-user-added-insurance.types";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {
  FormFieldsDto,
  FormFieldsDtoForInsurance,
  FormInsuranceFieldsDto,
  OnboardingDto
} from "../../types/ob.interfaces";
import {AutoCompleteCompleteEvent} from "primeng/autocomplete";
import {InsurableObjectService} from "../../../cross/user-insurance/api/user-added-insurance-api.service";
import {Observable} from "rxjs";
import {UploadDocumentType} from "../../../core/component/core-upload/core-upload.component";
import {OnboardingService} from "../../api/onboarding.service";
import {AppMessageService} from "../../../core/service/app-message.service";
import {MessageHelper} from "../../../core/helper/message-helper";
import {ConfirmationService} from "primeng/api";
import {ActivatedRoute} from "@angular/router";
import {
  EuEuUserAddedInsuranceStatusInternal
} from "../../../cross/user-insurance/enums/eu-user-added-insurance-status-internal.enum";
import {FieldAccess} from "../../../rg/types/registration.types";

@Component({
  selector: 'upload-contract',
  templateUrl: 'upload-contract.component.html',
  styleUrls: ['upload-contract.component.css']
})
export class UploadContractComponent extends CoreComponent {

  @Input() onboardingDto: OnboardingDto | undefined;

  insuranceFieldsList: FormFieldsDtoForInsurance[] | undefined;
  userAddedInsuranceDto: UserAddedInsuranceDto[] | undefined;
  selectedUserAddedInsuranceDto: UserAddedInsuranceDto | undefined;
  selectedInsuranceForm: FormGroup | undefined;
  insuranceForm: FormGroup | undefined;
  tempForm: FormGroup | undefined;
  selectedDocument: UserAddedInsuranceDocumentDto | undefined;
  visible: boolean = false;
  documentVisible: boolean = false;
  blob: string | undefined;
  fileUploadStatus: boolean | undefined;
  logonToken!: string;
  urlPath!: string;

  constructor(
    protected confirmationService: ConfirmationService,
    protected messageService: AppMessageService,
    protected insurableObjectService: InsurableObjectService,
    private fb: FormBuilder,
    protected onboardingService: OnboardingService,
    protected route: ActivatedRoute,
    ) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.route.queryParamMap.subscribe((params) => {
      this.logonToken = params.get('logon_token') || '';
      if(this.logonToken)
      localStorage.setItem('igToken', this.logonToken);
    })

    if (this.onboardingDto) {
      this.initComponent();
    } else {
      this.onboardingService.getOnboardingOnRegistration().subscribe(res => {
        this.onboardingDto = res;
        this.initComponent();
      }, error => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);

      })
    }
  }


  initComponent() {
    this.handleInsuranceFormGroup();
    this.listUserInsurances();
    this.changeInsuranceFormToArray()
  }


  refreshComponent() {
    this.initialized = true;
  }

  showDialog() {
    this.visible = true;
  }

  changeInsuranceFormToArray() {

    if (this.onboardingDto) {

      this.insuranceFieldsList = Object.values(this.onboardingDto.formInsurance.formFields).sort((a, b) => a.order - b.order);

      /*
      this.insuranceFieldsList = Object.entries(this.onboardingDto.formInsurance.formFields).map(([key, value]) => ({
        key,
        ...value,
      }));
       */
    }
  }


  onSaveInsuranceForm(form: FormGroup) {

    if (this.busy) {
      return;
    }

    this.busy = true;

    const dto: UserAddedInsuranceDto = form.value as UserAddedInsuranceDto;
    this.getInsurableObjectObservable(dto).subscribe(res => {
      this.busy = false;
      this.buildInsuranceFormGroup();
      this.listUserInsurances();
      this.messageService.showSuccessMessage('', 'Daten gespeichert');
      this.visible = false;
    }, error => {
      this.busy = false;
      // this.messageService.showErrorMessage('Speicherung', 'Leider ist ein Fehler aufgetreten.');
      MessageHelper.showErrorMessage('Leider ist ein Fehler aufgetreten.', this.messageService);
    });
  }

  onDeleteInsuranceForm(id: number) {
    if (this.busy) {
      return;
    }
    this.busy = true;
    this.insurableObjectService.delete(id).subscribe(res => {
      this.busy = false;
      this.listUserInsurances();
      this.messageService.showInfoMessage('', 'Daten erfolgreich gelöscht');
      this.visible = false;
    }, error => {
      // this.messageService.showErrorMessage('Löschung', 'Leider ist ein Fehler aufgetreten.');
      MessageHelper.showErrorMessage('Leider ist ein Fehler aufgetreten.', this.messageService);
    });
  }

  onDeleteDocument(event: MouseEvent, insuranceId: number, documentId: number) {
    if (this.busy) {
      return;
    }
    this.busy = true;
    event.stopPropagation();

    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Bist du dir sicher?',
      header: 'Bestätigung',
      icon: 'pi pi-exclamation-triangle text-red-500',
      acceptIcon: "none",
      rejectIcon: "none",
      acceptLabel:'Ja',
      rejectLabel:'Nein',
      rejectButtonStyleClass: "p-button-text",
      accept: () => {
        this.insurableObjectService.deleteDocument(insuranceId, documentId).subscribe(res => {
          this.listUserInsurances();
          this.messageService.showInfoMessage('', 'Dokument wurde gelöscht.');
          this.busy = false;
          this.visible = false;
        }, error => {
          // this.messageService.showErrorMessage('', 'Leider ist ein Fehler bei der Dokumentenlöschung aufgetreten');
          MessageHelper.showErrorMessage('Leider ist ein Fehler bei der Dokumentenlöschung aufgetreten', this.messageService);
          this.busy = false;
        })
      },
      reject: () => {
        this.busy = false;
        this.messageService.showErrorMessage('Abgelehnt', 'Ihre Anfrage wurde abgelehnt.');
      }
    });


  }

  getInsurableObjectObservable(dto: UserAddedInsuranceDto): Observable<UserAddedInsuranceDto> {
    if (dto.id) {
      return this.insurableObjectService.update(dto);
    } else {

      return this.insurableObjectService.create(dto);
    }
  }


  // listUserInsurances() {
  //   this.insurableObjectService.list().subscribe(res => {
  //     this.userAddedInsuranceDto = res;
  //     this.userAddedInsuranceDto.sort((a, b) => b.id - a.id);
  //     this.refreshComponent();
  //   }, error => {
  //     MessageHelper.showErrorMessage(error.error.data, this.messageService);
  //   })
  // }

  // listUserInsurances() {
  //   this.insurableObjectService.list().subscribe({
  //     next: (res) => {
  //       // Filter first, then sort (order doesn’t matter much, but this is logical)
  //       this.userAddedInsuranceDto = (res ?? [])
  //         .filter(
  //           i =>
  //             i?.status === EuEuUserAddedInsuranceStatusInternal.pending ||
  //             i?.status === EuEuUserAddedInsuranceStatusInternal.in_processing
  //         )
  //         .sort((a, b) => b.id - a.id);
  //
  //       this.refreshComponent();
  //     },
  //     error: (error) => {
  //       MessageHelper.showErrorMessage(error.error.data, this.messageService);
  //     }
  //   });
  // }

  listUserInsurances() {
    this.insurableObjectService.list().subscribe({
      next: (res) => {
        const all = res ?? [];

        // ✅ Include null statuses, but filter only those that should appear
        this.userAddedInsuranceDto = all
          .filter(i =>
            i?.status === null ||
            i?.status === undefined ||
            i?.status === EuEuUserAddedInsuranceStatusInternal.pending ||
            i?.status === EuEuUserAddedInsuranceStatusInternal.in_processing
          )
          // ✅ Optional: sort by ID descending (newest first)
          .sort((a, b) => b.id - a.id);

        this.refreshComponent();
      },
      error: (error) => {
        MessageHelper.showErrorMessage(error.error.data, this.messageService);
      }
    });
  }

  onSelectUserInsurance(insurance: UserAddedInsuranceDto) {
    if (this.busy) {
      return;
    }
    this.busy = true;
    this.insurableObjectService.get(insurance.id).subscribe(res => {
      this.busy = false;
      this.selectedUserAddedInsuranceDto = res;
      this.selectedInsuranceForm = undefined;

      if (this.onboardingDto?.formInsurance?.formFields) {
        this.selectedInsuranceForm = this.buildUiForm(this.onboardingDto?.formInsurance?.formFields);
      }
      this.patchInsuranceData(insurance);
      this.tempForm = this.selectedInsuranceForm;
      this.visible = true;
    }, error => {
      MessageHelper.showErrorMessage(error.error.data, this.messageService);
      this.busy = false;
    });

  }


  patchInsuranceData(insuranceData: UserAddedInsuranceDto) {
    if (this.selectedInsuranceForm) {

      const object: { [key: string]: any } = {};
      for (let insuranceDataKey in insuranceData) {
        let key = insuranceDataKey;

        if (key.includes('insuranceType')) {
          key = key.replace('insuranceType', 'contractType');
        } else if (key.includes('insuranceCompanyDto')) {
          key = key.replace('insuranceCompanyDto', 'partnerDto');
        }

        object[key] = insuranceData[insuranceDataKey as keyof UserAddedInsuranceDto];
      }

      this.selectedInsuranceForm.patchValue(object);
    }
  }

  onDialogHide() {
    this.selectedDocument = undefined;
    this.handleInsuranceFormGroup();
  }

  handleInsuranceFormGroup() {
    this.buildInsuranceFormGroup()
    this.tempForm = this.insuranceForm;
  }

  buildInsuranceFormGroup() {
    if (this.onboardingDto?.formInsurance?.formFields) {
      this.insuranceForm = this.buildUiForm(this.onboardingDto?.formInsurance?.formFields);
    }
  }


  buildUiForm(formFields: FormInsuranceFieldsDto): FormGroup {
    const group: { [key: string]: any } = {};
    for (let formFieldsKey in formFields) {
      const field = formFields[formFieldsKey];
      const validators = [];

      if (field.uiMandatory && field.access == FieldAccess.UPDATE) {
        validators.push(Validators.required);
      }

      if (field.id == 'partnerDtoId' || field.id == 'contractTypeDtoId') {
        field.uiMandatory = true;
        validators.push(Validators.required);
      }

      group[field.id] = [field.value, validators];
    }

    return this.fb.group(group);
  }

  isFormValid() {
    const partner = this.tempForm?.get('partnerDtoId')?.value;
    const contractType = this.tempForm?.get('contractTypeDtoId')?.value;

    if (partner == null || contractType == null) {
      return false;
    }
    return true;
  }

  showDocument(event: MouseEvent, document: UserAddedInsuranceDocumentDto) {
    event.stopPropagation();
    if (document.id) {
      if (this.busy) {
        return;
      }
      this.selectedDocument = document;
      this.busy = true;
      this.insurableObjectService.getDocumentBinary(document.insuranceId, document.id).subscribe(res => {
        this.blob = res;
        this.documentVisible = true;
        this.busy = false;
      }, error => {
        this.busy = false;
        MessageHelper.showErrorMessage(error.error.data, this.messageService);
      })
    }
  }


  onDocumentUpload(document: UploadDocumentType[]) {
    const userAddedInsurance: Partial<UserAddedInsuranceDto> = {}
    if (this.busy) {
      return;
    }
    this.busy = true;
    let count = 0
    this.insurableObjectService.create(userAddedInsurance as UserAddedInsuranceDto).subscribe(res => {
      for (let doc of document) {
        const documentDto: UserAddedInsuranceDocumentDto = {
          insuranceId: res.id,
          name: doc.name,
          fileBase64: doc.fileBase64,
          fileBase64MimeType: doc.fileBase64MimeType
        };
        if (documentDto && documentDto?.insuranceId) {
          this.insurableObjectService.createDocumentBase64(documentDto.insuranceId, documentDto).subscribe(res => {
              count++;
              if (document.length == count) {
                this.busy = false;
                this.fileUploadStatus = !this.fileUploadStatus;
                this.listUserInsurances();
              }
            }, error => {
              MessageHelper.showErrorMessage(error.error.data, this.messageService);
              this.busy = false;
              this.fileUploadStatus = !this.fileUploadStatus;
            }
          );
        }
      }
    })

  }


  handleWindowOpened(event: boolean) {
    this.documentVisible = false;
  }


  protected readonly FieldAccess = FieldAccess;
}
